module.exports = __webpack_public_path__ + "img/弹窗_bg@2x.4f5c1e84.png";